"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRootElement = void 0;
var ssr_1 = require("@r1-frontend/shared/helpers/ssr");
/**
 * Coздает элемент в корне документа или возвращает
 * ссылку на него, если он существует
 * @param id Идентификатор элемента
 * @param tag Тег создаваемого элемента
 */
var createRootElement = function (id, tag) {
    if (tag === void 0) { tag = 'div'; }
    if (!(0, ssr_1.isClientSide)()) {
        return null;
    }
    var root = document.getElementById(id);
    if (!root) {
        root = document.createElement(tag);
        root.setAttribute('id', id);
        document.body.appendChild(root);
    }
    return root;
};
exports.createRootElement = createRootElement;
